import React, { useState } from 'react'
import { Subscribe } from 'unstated'
import { Portal } from 'react-portal'
import Button from '../../../../../Components/Buttons/Button'
import Textarea from 'react-textarea-autosize'
import CourseStore from '../../../Store/CourseStore'
import date from 'date-and-time'
import { getFirstWeekSlots } from '../../../../../Modules/Calendar/Helpers/Calendar'
import Success from '../../../../../Components/Success/Success'

const EnrollmentRequestModal = ({ close }) => {
  const [message, updateMessage] = useState('')
  const [pending, setPending] = useState(false)
  const [success, setSuccess] = useState(false)
  return (
    <Subscribe to={[CourseStore]}>
      {({ state, enroll }) => (
        <Portal>
          {success && (
            <Success
              heading={`Your enrollment request for the course ${state.name} has been sent to ${state.teacher.name}.`}
              subText={`You will be notified when ${state.teacher.name} accepts your enrollment requests.`}
              secondary={{
                hidden: true,
              }}
              primary={{
                name: 'Go to home',
                route: '/',
              }}
            />
          )}

          <div className='enrollmentRequestModal' onClick={close}>
            <div className='modal' onClick={(e) => e.stopPropagation()}>
              <div className='close' onClick={close} />
              <div className='row'>
                <h1>Course:</h1>
                <p>{state.name}</p>
              </div>
              <div className='row'>
                <h1>Timings:</h1>
                <p>
                  {getFirstWeekSlots(state.enrollmentSlots).map((slot, i) => (
                    <span key={'calendarSlotsForEnrollment' + i}>
                      {date
                        .format(new Date(slot.startTime), 'dddd: hh:mm A - ')
                        .toUpperCase()}
                      {date
                        .format(new Date(slot.endTime), 'hh:mm A')
                        .toUpperCase()}
                    </span>
                  ))}
                </p>
              </div>
              <div className='row'>
                <Textarea
                  name='enrollMessage'
                  value={message}
                  onChange={(e) => updateMessage(e.target.value)}
                />
              </div>
              <div className='row'>
                <Button
                  onClick={async () => {
                    setPending(true)
                    const success = await enroll(message)
                    setPending(false)
                    if (success) {
                      setSuccess(true)
                    }
                  }}
                  name={'Send'}
                  type={'primary big'}
                  disabled={pending || !message}
                />
              </div>
            </div>
          </div>
        </Portal>
      )}
    </Subscribe>
  )
}

export default EnrollmentRequestModal
